import React, {useState} from 'react';
import _ from 'underscore';

import {SchemaTag} from 'folder-items/FileConstants';
import TagValueEditor from 'metadata/TagValueEditor';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';
import {ButtonStyle} from 'ui-library/buttons/Button';
import ModalAnchor from 'ui-library/ModalAnchor';
import Modal from 'ui-library/modals/Modal';
import * as keyboard from 'util/Keyboard';
import {ElementKeyboardEvent} from 'util/Types';

interface TagValueInputModalProps {
  onEscape: () => void;
  onSetTagValue: (tagValue: SchemaTag, enterKey: boolean) => void;
  schemaField: SchemaField;
  tagValue: SchemaTag;
}

export default function TagValueInputModal(props: TagValueInputModalProps): JSX.Element {
  const [tagValue, setRawTagValue] = useState(props.tagValue);

  function handleSetTagValue(newTagValue: Partial<SchemaTag>): void {
    setRawTagValue({...tagValue, ...newTagValue});
  }

  function handleKeyDown(e: ElementKeyboardEvent): void {
    if (keyboard.isEnterKey(e)) {
      // Avoid re-opening the modal with the same keypress that closed the modal
      _.defer(() => {
        handleSubmit(true);
      });
    }
  }

  function handleSubmit(enterKey: boolean): void {
    props.onSetTagValue(tagValue, enterKey);
  }

  return (
    <ModalAnchor open={true}>
      <Modal
        title="Select options"
        onRequestClose={props.onEscape}
        buttons={[
          {
            text: 'Submit',
            style: ButtonStyle.SECONDARY,
            onClick: () => {
              handleSubmit(false);
            },
          },
        ]}
      >
        <div className="u-mini-spacing-bottom">
          <TagValueEditor
            autoFocus={true}
            itemLinkAllowed={false}
            onChange={handleSetTagValue}
            onKeyDown={handleKeyDown}
            schemaFieldSelectorId={props.schemaField.schemaFieldSelectorId}
            tag={tagValue}
          />
        </div>
      </Modal>
    </ModalAnchor>
  );
}
